module.exports = {
  "60004": {
    "latitude": 42.108428,
    "longitude": -87.97723
  },
  "60005": {
    "latitude": 42.069327,
    "longitude": -87.98464
  },
  "60006": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60007": {
    "latitude": 42.005978,
    "longitude": -87.99847
  },
  "60008": {
    "latitude": 42.07506,
    "longitude": -88.02508
  },
  "60009": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60010": {
    "latitude": 42.123128,
    "longitude": -88.139128
  },
  "60016": {
    "latitude": 42.047178,
    "longitude": -87.89058
  },
  "60017": {
    "latitude": 42.028779,
    "longitude": -87.894366
  },
  "60018": {
    "latitude": 42.008429,
    "longitude": -87.89234
  },
  "60019": {
    "latitude": 42.024278,
    "longitude": -87.907066
  },
  "60022": {
    "latitude": 42.130976,
    "longitude": -87.76252
  },
  "60025": {
    "latitude": 42.07672,
    "longitude": -87.81922
  },
  "60026": {
    "latitude": 42.09166,
    "longitude": -87.837363
  },
  "60029": {
    "latitude": 42.056529,
    "longitude": -87.79286
  },
  "60038": {
    "latitude": 42.097976,
    "longitude": -88.014072
  },
  "60043": {
    "latitude": 42.088128,
    "longitude": -87.716
  },
  "60053": {
    "latitude": 42.041999,
    "longitude": -87.78882
  },
  "60055": {
    "latitude": 42.097976,
    "longitude": -88.014072
  },
  "60056": {
    "latitude": 42.065427,
    "longitude": -87.93621
  },
  "60062": {
    "latitude": 42.124576,
    "longitude": -87.84303
  },
  "60065": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60067": {
    "latitude": 42.10979,
    "longitude": -88.04917
  },
  "60068": {
    "latitude": 42.01183,
    "longitude": -87.84158
  },
  "60070": {
    "latitude": 42.105576,
    "longitude": -87.92816
  },
  "60074": {
    "latitude": 42.143819,
    "longitude": -88.02546
  },
  "60076": {
    "latitude": 42.03618,
    "longitude": -87.7321
  },
  "60077": {
    "latitude": 42.033313,
    "longitude": -87.75764
  },
  "60078": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60082": {
    "latitude": 42.116377,
    "longitude": -87.812064
  },
  "60089": {
    "latitude": 42.168417,
    "longitude": -87.9593
  },
  "60090": {
    "latitude": 42.131526,
    "longitude": -87.92958
  },
  "60091": {
    "latitude": 42.077178,
    "longitude": -87.72373
  },
  "60093": {
    "latitude": 42.104127,
    "longitude": -87.75016
  },
  "60094": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60095": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60103": {
    "latitude": 41.98818,
    "longitude": -88.211
  },
  "60104": {
    "latitude": 41.882924,
    "longitude": -87.87642
  },
  "60106": {
    "latitude": 41.956492,
    "longitude": -87.94108707
  },
  "60107": {
    "latitude": 42.023977,
    "longitude": -88.17657
  },
  "60120": {
    "latitude": 42.036825,
    "longitude": -88.243082
  },
  "60126": {
    "latitude": 41.899585,
    "longitude": -87.929752
  },
  "60130": {
    "latitude": 41.871331,
    "longitude": -87.81235
  },
  "60131": {
    "latitude": 41.93548,
    "longitude": -87.87468
  },
  "60133": {
    "latitude": 41.980896,
    "longitude": -88.144475
  },
  "60141": {
    "latitude": 41.858028,
    "longitude": -87.83865
  },
  "60153": {
    "latitude": 41.880281,
    "longitude": -87.84455
  },
  "60154": {
    "latitude": 41.851257,
    "longitude": -87.88351
  },
  "60155": {
    "latitude": 41.857931,
    "longitude": -87.85477
  },
  "60159": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60160": {
    "latitude": 41.89988,
    "longitude": -87.85978
  },
  "60161": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60162": {
    "latitude": 41.872997,
    "longitude": -87.90101
  },
  "60163": {
    "latitude": 41.886794,
    "longitude": -87.91052
  },
  "60164": {
    "latitude": 41.91823,
    "longitude": -87.89627
  },
  "60165": {
    "latitude": 41.90158,
    "longitude": -87.88046
  },
  "60168": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60169": {
    "latitude": 42.0484946,
    "longitude": -88.1029653
  },
  "60171": {
    "latitude": 41.92583,
    "longitude": -87.84013
  },
  "60172": {
    "latitude": 41.982427,
    "longitude": -88.072993
  },
  "60173": {
    "latitude": 42.051927,
    "longitude": -88.04814
  },
  "60176": {
    "latitude": 41.95683,
    "longitude": -87.87193
  },
  "60179": {
    "latitude": 42.079336,
    "longitude": -88.223655
  },
  "60191": {
    "latitude": 41.965208,
    "longitude": -87.970695
  },
  "60192": {
    "latitude": 42.065827,
    "longitude": -88.21399
  },
  "60193": {
    "latitude": 42.01299,
    "longitude": -88.09675
  },
  "60194": {
    "latitude": 42.037108,
    "longitude": -88.10719
  },
  "60195": {
    "latitude": 42.067809,
    "longitude": -88.10828
  },
  "60196": {
    "latitude": 42.056376,
    "longitude": -88.072522
  },
  "60201": {
    "latitude": 42.056391,
    "longitude": -87.69684
  },
  "60202": {
    "latitude": 42.030327,
    "longitude": -87.68828
  },
  "60203": {
    "latitude": 42.048879,
    "longitude": -87.7175
  },
  "60204": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60208": {
    "latitude": 42.058629,
    "longitude": -87.684506
  },
  "60209": {
    "latitude": 42.04973,
    "longitude": -87.679408
  },
  "60301": {
    "latitude": 41.887981,
    "longitude": -87.79562
  },
  "60302": {
    "latitude": 41.893941,
    "longitude": -87.78899
  },
  "60303": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60304": {
    "latitude": 41.87355,
    "longitude": -87.7885
  },
  "60305": {
    "latitude": 41.893031,
    "longitude": -87.81718
  },
  "60402": {
    "latitude": 41.836981,
    "longitude": -87.79095
  },
  "60406": {
    "latitude": 41.656592,
    "longitude": -87.68154
  },
  "60409": {
    "latitude": 41.614188,
    "longitude": -87.54638
  },
  "60411": {
    "latitude": 41.511307,
    "longitude": -87.6101
  },
  "60412": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60415": {
    "latitude": 41.702482,
    "longitude": -87.77869
  },
  "60419": {
    "latitude": 41.626839,
    "longitude": -87.59865
  },
  "60422": {
    "latitude": 41.539384,
    "longitude": -87.68424
  },
  "60423": {
    "latitude": 41.486347,
    "longitude": -87.815811
  },
  "60425": {
    "latitude": 41.544584,
    "longitude": -87.61289
  },
  "60426": {
    "latitude": 41.609078,
    "longitude": -87.66264
  },
  "60428": {
    "latitude": 41.6003571,
    "longitude": -87.6850596
  },
  "60429": {
    "latitude": 41.574034,
    "longitude": -87.67857
  },
  "60430": {
    "latitude": 41.556734,
    "longitude": -87.66464
  },
  "60438": {
    "latitude": 41.565685,
    "longitude": -87.54819
  },
  "60439": {
    "latitude": 41.676028,
    "longitude": -87.98258
  },
  "60443": {
    "latitude": 41.503468,
    "longitude": -87.73695
  },
  "60445": {
    "latitude": 41.631683,
    "longitude": -87.73309
  },
  "60452": {
    "latitude": 41.605633,
    "longitude": -87.75356
  },
  "60453": {
    "latitude": 41.715082,
    "longitude": -87.7546
  },
  "60454": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60455": {
    "latitude": 41.742432,
    "longitude": -87.80678
  },
  "60456": {
    "latitude": 41.730533,
    "longitude": -87.73198
  },
  "60457": {
    "latitude": 41.723782,
    "longitude": -87.82825
  },
  "60458": {
    "latitude": 41.746432,
    "longitude": -87.83557
  },
  "60459": {
    "latitude": 41.744082,
    "longitude": -87.77022
  },
  "60461": {
    "latitude": 41.51829,
    "longitude": -87.69274
  },
  "60462": {
    "latitude": 41.623532,
    "longitude": -87.83542
  },
  "60463": {
    "latitude": 41.663548,
    "longitude": -87.79148
  },
  "60464": {
    "latitude": 41.664582,
    "longitude": -87.84378
  },
  "60465": {
    "latitude": 41.699432,
    "longitude": -87.82977
  },
  "60466": {
    "latitude": 41.472934,
    "longitude": -87.68767
  },
  "60467": {
    "latitude": 41.598255,
    "longitude": -87.89201
  },
  "60469": {
    "latitude": 41.628034,
    "longitude": -87.68694
  },
  "60471": {
    "latitude": 41.483844,
    "longitude": -87.72134
  },
  "60472": {
    "latitude": 41.642933,
    "longitude": -87.70814
  },
  "60473": {
    "latitude": 41.597472,
    "longitude": -87.59909
  },
  "60475": {
    "latitude": 41.470084,
    "longitude": -87.63369
  },
  "60476": {
    "latitude": 41.570384,
    "longitude": -87.60839
  },
  "60477": {
    "latitude": 41.5738,
    "longitude": -87.80389
  },
  "60478": {
    "latitude": 41.561134,
    "longitude": -87.72398
  },
  "60480": {
    "latitude": 41.737616,
    "longitude": -87.87778
  },
  "60482": {
    "latitude": 41.688827,
    "longitude": -87.79265
  },
  "60487": {
    "latitude": 41.5626449,
    "longitude": -87.8295843
  },
  "60491": {
    "latitude": 41.606661,
    "longitude": -87.933905
  },
  "60499": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60501": {
    "latitude": 41.784832,
    "longitude": -87.81
  },
  "60513": {
    "latitude": 41.822681,
    "longitude": -87.84753
  },
  "60515": {
    "latitude": 41.796156,
    "longitude": -87.999368
  },
  "60516": {
    "latitude": 41.796156,
    "longitude": -87.999368
  },
  "60521": {
    "latitude": 41.807076,
    "longitude": -87.918533
  },
  "60523": {
    "latitude": 41.836529,
    "longitude": -87.938546
  },
  "60525": {
    "latitude": 41.788536,
    "longitude": -87.87605
  },
  "60526": {
    "latitude": 41.829831,
    "longitude": -87.8704
  },
  "60527": {
    "latitude": 41.743315,
    "longitude": -87.912758
  },
  "60534": {
    "latitude": 41.812331,
    "longitude": -87.82318
  },
  "60540": {
    "latitude": 41.764489,
    "longitude": -88.122402
  },
  "60546": {
    "latitude": 41.836131,
    "longitude": -87.82163
  },
  "60558": {
    "latitude": 41.805531,
    "longitude": -87.90103
  },
  "60563": {
    "latitude": 41.764489,
    "longitude": -88.122402
  },
  "60564": {
    "latitude": 41.764489,
    "longitude": -88.122402
  },
  "60565": {
    "latitude": 41.764489,
    "longitude": -88.122402
  },
  "60566": {
    "latitude": 41.764489,
    "longitude": -88.122402
  },
  "60567": {
    "latitude": 41.764489,
    "longitude": -88.122402
  },
  "60601": {
    "latitude": 41.886456,
    "longitude": -87.62325
  },
  "60602": {
    "latitude": 41.882937,
    "longitude": -87.62874
  },
  "60603": {
    "latitude": 41.880446,
    "longitude": -87.63014
  },
  "60604": {
    "latitude": 41.877589,
    "longitude": -87.62818
  },
  "60605": {
    "latitude": 41.860019,
    "longitude": -87.6187
  },
  "60606": {
    "latitude": 41.882582,
    "longitude": -87.6376
  },
  "60607": {
    "latitude": 41.875882,
    "longitude": -87.65114
  },
  "60608": {
    "latitude": 41.850532,
    "longitude": -87.6699
  },
  "60609": {
    "latitude": 41.814283,
    "longitude": -87.65282
  },
  "60610": {
    "latitude": 41.898582,
    "longitude": -87.6371
  },
  "60611": {
    "latitude": 41.904667,
    "longitude": -87.62504
  },
  "60612": {
    "latitude": 41.880682,
    "longitude": -87.6877
  },
  "60613": {
    "latitude": 41.953256,
    "longitude": -87.6629
  },
  "60614": {
    "latitude": 41.922682,
    "longitude": -87.65432
  },
  "60615": {
    "latitude": 41.801525,
    "longitude": -87.60215
  },
  "60616": {
    "latitude": 41.8474,
    "longitude": -87.63126
  },
  "60617": {
    "latitude": 41.719973,
    "longitude": -87.5557
  },
  "60618": {
    "latitude": 41.945681,
    "longitude": -87.7048
  },
  "60619": {
    "latitude": 41.744834,
    "longitude": -87.60444
  },
  "60620": {
    "latitude": 41.740483,
    "longitude": -87.65282
  },
  "60621": {
    "latitude": 41.776983,
    "longitude": -87.6404
  },
  "60622": {
    "latitude": 41.900332,
    "longitude": -87.66927
  },
  "60623": {
    "latitude": 41.850232,
    "longitude": -87.718
  },
  "60624": {
    "latitude": 41.879365,
    "longitude": -87.72199
  },
  "60625": {
    "latitude": 41.971614,
    "longitude": -87.70256
  },
  "60626": {
    "latitude": 42.009731,
    "longitude": -87.66938
  },
  "60628": {
    "latitude": 41.695434,
    "longitude": -87.62255
  },
  "60629": {
    "latitude": 41.777482,
    "longitude": -87.71155
  },
  "60630": {
    "latitude": 41.971044,
    "longitude": -87.75869
  },
  "60631": {
    "latitude": 41.99623,
    "longitude": -87.81091
  },
  "60632": {
    "latitude": 41.809299,
    "longitude": -87.7105
  },
  "60633": {
    "latitude": 41.655423,
    "longitude": -87.55365
  },
  "60634": {
    "latitude": 41.944454,
    "longitude": -87.79654
  },
  "60636": {
    "latitude": 41.776633,
    "longitude": -87.66854
  },
  "60637": {
    "latitude": 41.779384,
    "longitude": -87.60544
  },
  "60638": {
    "latitude": 41.787982,
    "longitude": -87.7738
  },
  "60639": {
    "latitude": 41.921431,
    "longitude": -87.75415
  },
  "60640": {
    "latitude": 41.973181,
    "longitude": -87.6665
  },
  "60641": {
    "latitude": 41.946431,
    "longitude": -87.74576
  },
  "60642": {
    "latitude": 41.9016822,
    "longitude": -87.6477859
  },
  "60643": {
    "latitude": 41.696433,
    "longitude": -87.65993
  },
  "60644": {
    "latitude": 41.881331,
    "longitude": -87.75671
  },
  "60645": {
    "latitude": 42.008956,
    "longitude": -87.69634
  },
  "60646": {
    "latitude": 41.995331,
    "longitude": -87.7601
  },
  "60647": {
    "latitude": 41.921126,
    "longitude": -87.70085
  },
  "60649": {
    "latitude": 41.761734,
    "longitude": -87.57072
  },
  "60651": {
    "latitude": 41.901485,
    "longitude": -87.74055
  },
  "60652": {
    "latitude": 41.7446,
    "longitude": -87.71188
  },
  "60653": {
    "latitude": 41.819833,
    "longitude": -87.61269
  },
  "60654": {
    "latitude": 41.888627,
    "longitude": -87.63538
  },
  "60655": {
    "latitude": 41.696283,
    "longitude": -87.69912
  },
  "60656": {
    "latitude": 41.97508,
    "longitude": -87.8163
  },
  "60657": {
    "latitude": 41.940832,
    "longitude": -87.65852
  },
  "60659": {
    "latitude": 41.991381,
    "longitude": -87.70378
  },
  "60660": {
    "latitude": 41.990631,
    "longitude": -87.6667
  },
  "60661": {
    "latitude": 41.882082,
    "longitude": -87.64461
  },
  "60664": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60666": {
    "latitude": 41.968029,
    "longitude": -87.891214
  },
  "60668": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60669": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60670": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60673": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60674": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60675": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60677": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60678": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60680": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60681": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60684": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60685": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60687": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60690": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60691": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60693": {
    "latitude": 42.096428,
    "longitude": -87.71791
  },
  "60694": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60697": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60699": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60701": {
    "latitude": 41.811929,
    "longitude": -87.68732
  },
  "60706": {
    "latitude": 41.96418,
    "longitude": -87.81686
  },
  "60707": {
    "latitude": 41.922681,
    "longitude": -87.80805
  },
  "60712": {
    "latitude": 42.005331,
    "longitude": -87.73545
  },
  "60714": {
    "latitude": 42.032379,
    "longitude": -87.81563
  },
  "60803": {
    "latitude": 41.675861,
    "longitude": -87.73189
  },
  "60804": {
    "latitude": 41.844382,
    "longitude": -87.7599
  },
  "60805": {
    "latitude": 41.719933,
    "longitude": -87.70249
  },
  "60827": {
    "latitude": 41.649717,
    "longitude": -87.63292
  }
}
